// src/pages/Dashboard.tsx
import { useEffect, useState } from "react";
import api from "../lib/api";

export default function Dashboard() {
  const [msg, setMsg] = useState("로딩 중...");

  useEffect(() => {
    let alive = true;

    // ✅ baseURL="/api" 이므로 "/me/profile" 만 호출해야 /api/me/profile 이 됨
    api
      .get("/me/profile")
      .then((res) => {
        if (!alive) return;
        setMsg(res.data?.message ?? "프로필을 불러왔습니다.");
      })
      .catch(() => {
        if (!alive) return;
        setMsg("인증 실패 또는 토큰 만료");
      });

    return () => {
      alive = false;
    };
  }, []);

  return (
    <div className="container-x py-10">
      <h2 className="text-2xl font-bold mb-2">대시보드</h2>
      <p>{msg}</p>
    </div>
  );
}
